import { render, staticRenderFns } from "./AppContainerComponent.vue?vue&type=template&id=675d22f4&"
import script from "./AppContainerComponent.vue?vue&type=script&lang=ts&"
export * from "./AppContainerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports